import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { ROUTES } from "@/constants/routes";
import { tryNavigateWithUnsavedGuard } from "@/helpers/unsavedChangesGuard";
import "./AppNavigation.css";

export type TabId =
  | "contractors"
  | "clients"
  | "feedback"
  | "gas-stations"
  | "help";

interface Tab {
  id: TabId;
  label: string;
  path: string;
}

interface AppNavigationProps {
  activeTab?: TabId;
  onTabChange?: (tab: TabId) => void;
}

const tabs: Tab[] = [
  { id: "contractors", label: "Контрагенты", path: ROUTES.CONTRACTORS },
  { id: "clients", label: "Клиенты", path: ROUTES.CLIENTS },
  { id: "gas-stations", label: "Заправки", path: ROUTES.GAS_STATIONS },
  { id: "feedback", label: "Обратная связь", path: ROUTES.FEEDBACK },
  { id: "help", label: "Помощь на дороге", path: ROUTES.HELP },
];

const AppNavigation = ({ activeTab, onTabChange }: AppNavigationProps) => {
  const navigate = useNavigate();

  const handleTabClick = (tab: Tab) => {
    tryNavigateWithUnsavedGuard(() => {
      navigate(tab.path);
      onTabChange?.(tab.id);
    });
  };

  return (
    <nav className="app-navigation" data-testid="nav">
      {tabs.map((tab) => {
        const tabClassName = classNames("app-navigation__tab", {
          "app-navigation__tab_active": activeTab === tab.id,
        });

        return (
          <button
            key={tab.id}
            className={tabClassName}
            onClick={() => handleTabClick(tab)}
            data-testid={`nav-${tab.id}`}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default AppNavigation;
